// CONSTANTS
import { ROUTE_DISCOVER_APP, ROUTE_DISCOVER_MOVIE, ROUTE_DISCOVER_SHOW } from '@/constants/routes';
import { ContentType } from '@/constants/watchList';

// UTILITY
import getLink from '@/utility/routes';
import { getDuration, getGenresNames } from '@/utility/content';

export default (data = {}) => {
  let itemList = {};

  if (data.itemList && Object.keys(data?.itemList)?.length) {
    let itemListElement = [];

    switch (data?.itemList?.content_type) {
      case 'app':
        itemListElement = data?.itemList?.data.map((item, index) => {
          const url = item?.unique_slug
            ? getLink(ROUTE_DISCOVER_APP, { slug: item?.unique_slug })
            : '';

          return {
            '@type': 'ListItem',
            position: index + 1,
            item: {
              '@type': 'BroadcastService',
              broadcastDisplayName: item?.name,
              name: item?.name,
              description: item?.desc,
              inLanguage: 'English',
              url,
              image: item?.thumbnail,
              logo: item?.thumbnail,
              offers: {
                '@type': 'Offer',
                availability: 'https://schema.org/InStock',
                price: item.price,
                priceCurrency: 'USD',
                url,
              },
            },
          };
        });
        break;
      case 'content':
        itemListElement = data?.itemList?.data.map((item, index) => {
          let itemData = {};
          let url;

          if (item.type === ContentType.SHOW) {
            url = item?.slug ? getLink(ROUTE_DISCOVER_SHOW, { show_id: item?.slug }) : '';

            itemData = {
              '@type': 'TVSeries',
              numberOfSeasons: item?.seasons_count || 0,
              startDate: item?.year_range?.start || '',
              endDate: item?.year_range?.end || '',
              datePublished: item?.year_range?.start || '',
            };
          } else if (item.type === ContentType.MOVIE) {
            url = item?.slug ? getLink(ROUTE_DISCOVER_MOVIE, { movie_id: item?.slug }) : '';

            itemData = {
              '@type': 'Movie',
              duration: {
                '@type': 'Duration',
                name: item?.duration ? getDuration(item.duration) : '',
              },
              contentRating: item?.rating,
              datePublished: item?.first_air_date,
              typicalAgeRange: item?.rating,
            };
          }

          return {
            '@type': 'ListItem',
            position: index + 1,
            item: {
              name: item?.title,
              description: item?.overview,
              genre: item?.genres?.length ? getGenresNames(data.genres) : '',
              thumbnailUrl: item?.thumbnail,
              image: item?.thumbnail,
              url,
              ...itemData,
            },
          };
        });
        break;
      default:
        break;
    }

    itemList = {
      numberOfItems: itemListElement.length,
      name: data?.title || '',
      itemListElement,
    };
  }

  const hasItems = !!Object.keys(itemList).length;

  return {
    '@type': hasItems ? ['WebPage', 'ItemList'] : ['WebPage'],
    name: data?.title,
    description: data?.description,
    inLanguage: 'English',
    url: data?.url,
    thumbnailUrl: data?.image || '',
    image: data?.image || '',
    ...itemList,
  };
};
